import { render } from "./App.vue?vue&type=template&id=3ce08882&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=3ce08882&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src1095094746/src/dapp.nftea.studio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ce08882"]])

export default __exports__